export const VisitingFacultyActions = {
  GET_VISITING_FACULTY: "GET_VISITING_FACULTY",
  SET_VISITING_FACULTY: "SET_VISITING_FACULTY",
};
